<template lang="pug">
    div
        //- Zero State
        section.wam-content.full-width(v-if="allocationData.length == 0 && !loading")
            section.l-flex-column.is-empty.zero-state
                p.zero-state-message Oh no 😕
                    |
                    br
                    | We could not find audiences with allocation on the account.
        
        div.dashboard-content(v-else)    
            spinner.l-flex-row--center.l-align-center(
                v-if="loading"
                width="150"
                height="150"
            )

            .l-flex-row(v-if="!loading")
                .dashboard-area_left
                    .l-flex-row
                        el-card(:style="isKibanaAllowed ? 'flex-basis: 50%; margin: 16px' : 'flex-basis: 100%; margin: 16px'")
                            .l-flex-row--between.l-align-center
                                div.total-values-dashboard-chip(style="background-color: #1811f1")
                                h1 Total Allocation
                                b {{ totalAllocations }}
                        el-card(v-if="isKibanaAllowed" style="flex-basis: 50%; margin: 16px")
                            .l-flex-row--between.l-align-center
                                div.total-values-dashboard-chip(style="background-color: #E6CF01")
                                h1.total-values-dashboard Total Affectation
                                b {{ totalAllocationsKibana }}

                    .l-flex-column
                        el-card(style="margin: 16px")
                            AllocationLinearGraph(
                                name="Audience allocation"
                                className="w-linechart--attribution"
                                :allocationMetrics="allocationMetrics"
                                :hasAccountAccessToKibanaStats="isKibanaAllowed"
                            )
                    
                .dashboard-area_right
                    el-card(style="margin: 16px")
                        AllocationDoughnut(
                            name="Audience allocation by source"
                            className="w-doughnutchart--attribution"
                            :allocationMetrics="allocationMetrics"
                        )
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { getAllocationMetrics } from '@/store/dashboard/helpers'
import { formatNumber } from '@/utils/helpers.js'
import AllocationLinearGraph from '@/components/dashboard/AllocationLinearGraph'
import AllocationDoughnut from '@/components/dashboard/AllocationDoughnut'

export default {
    name: 'AccountTab',

    components: {
        AllocationLinearGraph,
        AllocationDoughnut
    },

    props: {
        loading: { type: Boolean, default: false },
        allocationData: { type: Array, required: true },
        allocationTimeUnit: { type: String, required: true },
        kibanaData: { type: Object, required: false, default: () => ({}) }
    },

    computed: {
        ...mapState('dashboard', {
            selectedTimeRange: state => state.selectedTimeRange
        }),

        ...mapGetters('dashboard', ['isKibanaAllowed']),

        allocationMetrics() {
            return getAllocationMetrics(this.allocationData, this.allocationTimeUnit, this.kibanaData, this.selectedTimeRange[0], this.selectedTimeRange[1])
        },

        totalAllocations() {
            return formatNumber(this.allocationMetrics.totalAllocations)
        },

        totalAllocationsKibana() {
            return formatNumber(this.allocationMetrics.totalAllocationsKibana)
        }
    }
}
</script>
